import { ScoutingCenter } from 'components/scoutingCenter/stats/ScoutingCenter';

const ScoutingCenterPage = () => {
  return <ScoutingCenter />;
};
export default ScoutingCenterPage;
